import CheckBox from '@mui/icons-material/CheckBox';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function CheckBoxIcon(props: FixMe) {
  return <CheckBox {...props} />;
}

export default CheckBoxIcon;
